// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"e65ecb53","1280":"a2e445fd","1319":"cda2b68c","8862":"bc708970","9740":"8bd0756a"}[chunkId] + ".chunk.css";
};